module.exports = __webpack_public_path__ + "img/SKMJ_place8.3e97dd57.jpg";